import { render, staticRenderFns } from "./courseTypePriceInfo.vue?vue&type=template&id=e5dbdd62&"
import script from "./courseTypePriceInfo.vue?vue&type=script&lang=js&"
export * from "./courseTypePriceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports